import { render, staticRenderFns } from "./SchemeList.vue?vue&type=template&id=851b08a6&scoped=true"
import script from "./SchemeList.vue?vue&type=script&lang=js"
export * from "./SchemeList.vue?vue&type=script&lang=js"
import style0 from "./SchemeList.vue?vue&type=style&index=0&id=851b08a6&prod&lang=less&scoped=true"
import style1 from "./SchemeList.vue?vue&type=style&index=1&id=851b08a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851b08a6",
  null
  
)

export default component.exports